import { gql, useQuery } from "@apollo/client";

const GET_SALES = gql`
  query GetRecoveries(
    $region: ID
    $district: ID
    $tariffClass: ID
    $serviceClass: ServiceClass
    $month: PositiveInt!
    $year: PositiveInt!
    $page: Int
    $pageSize: Int
    $search: String
    $searchFields: [String!]
    $sort: String
  ) {
    rows: getRecoveries(
      region: $region
      district: $district
      tariffClass: $tariffClass
      serviceClass: $serviceClass
      month: $month
      year: $year
      page: $page
      pageSize: $pageSize
      search: $search
      searchFields: $searchFields
      sort: $sort
    ) {
      _id
      code
      billType
      servicePointCode
      servicePointStatus
      tariffClassCode
      tariffClassName
      serviceClass
      geoCode
      accountCode
      meterCode
      meterModelType
      regionCode
      regionName
      districtCode
      districtName

      customerName
      customerPhone
      ghanaPostAddress
      detectionDate
      fraudType
      billDate
      informantName
      billerCode
      billerName

      meterCost
      administrativeCharge
      otherCharges

      billConsumptionValue
      lifeLineAmount
      firstThresholdAmount
      secondThresholdAmount
      energyCharge
      serviceCharge
      energyPlusServiceCharge
      powerFactorSurcharge
      vatCharge
      nhilCharge
      getfundCharge
      streetLightCharge
      nationalElectrificationCharge
      billAmount
      paymentsAmount
      amountDue
      billAvgConsumptionValue
      month
      year
      createdAt
      updatedAt
    }
    count: getRecoveriesCount(
      region: $region
      district: $district
      tariffClass: $tariffClass
      serviceClass: $serviceClass
      month: $month
      year: $year
      search: $search
      searchFields: $searchFields
    )
  }
`;

export const useRecoveries = (variables: any) => {
  const { data, ...rest } = useQuery(GET_SALES, {
    variables,
    notifyOnNetworkStatusChange: true,
  });
  const rows = data?.rows || [];
  const count = data?.count || 0;
  return { rows, count, ...rest };
};
